var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRrInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fi-rr-info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.912,
    height: 10.912,
    viewBox: "0 0 10.912 10.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6326",
    "data-name": "Path 6326",
    d: "M5.456,0a5.456,5.456,0,1,0,5.456,5.456A5.456,5.456,0,0,0,5.456,0Zm0,10A4.547,4.547,0,1,1,10,5.456,4.547,4.547,0,0,1,5.456,10Z",
    fill: "#bbc6d1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6327",
    "data-name": "Path 6327",
    d: "M10.909,10h-.455a.455.455,0,0,0,0,.909h.455v2.728a.455.455,0,0,0,.909,0V10.909A.909.909,0,0,0,10.909,10Z",
    transform: "translate(-5.453 -5.453)",
    fill: "#bbc6d1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 0.682,
    cy: 0.682,
    r: 0.682,
    transform: "translate(4.774 2.273)",
    fill: "#bbc6d1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrInfo);
export default __webpack_public_path__ + "static/media/fi-rr-info.f30b7701f18b7aaefb1bf479cdc94b9d.svg";
export { ForwardRef as ReactComponent };